import React, { useState, useEffect } from "react";
import { Clock, Users, BookOpen, Phone, Video } from "lucide-react";

export default function TradingFundamentalsCourse() {
  const [timeLeft, setTimeLeft] = useState(7200); // 2 hours countdown

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = timeLeft % 60;

  return (
    <section className="mx-auto w-full max-w-5xl rounded-2xl border border-white/10 bg-[#0B0F19] px-4 py-12 text-white shadow-xl">
      {/* Header */}
      <div className="relative overflow-hidden rounded-2xl border border-white/10">
        <img
          src="/assets/courses/tradingfundamentals-banner.jpg"
          alt="Live Webinar"
          className="h-[320px] w-full object-cover opacity-90"
        />
        <div className="absolute inset-0 flex flex-col justify-end bg-gradient-to-t from-black/80 to-transparent p-6">
          <h2 className="text-3xl font-bold">
            Trading Fundamentals — Live Webinar
          </h2>
          <p className="mt-1 text-sm text-gray-300">
            Learn the basics of forex and global market trading from industry
            experts.
          </p>
        </div>
      </div>

      {/* Course Info */}
      <div className="mt-8 grid gap-6 md:grid-cols-2">
        {/* Left: Details */}
        <div>
          <h3 className="mb-4 flex items-center gap-2 text-xl font-semibold">
            <BookOpen className="h-5 w-5 text-blue-400" /> Course Overview
          </h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li>• Understanding Market Basics and Price Movements</li>
            <li>• Introduction to Forex, Indices, Commodities, and Crypto</li>
            <li>• How to Read Charts and Identify Trends</li>
            <li>• Understanding Leverage, Margin, and Risk Management</li>
            <li>• Setting Up Your First Trading Account (MT4/MT5)</li>
            <li>• Live Q&A Session with Certified Trading Coach</li>
          </ul>
          <div className="mt-6 text-sm text-gray-400">
            <Clock className="mr-1 inline h-4 w-4 text-yellow-400" /> Starts in:{" "}
            {hours}h {minutes}m {seconds}s
          </div>
        </div>

        {/* Right: Actions */}
        <div className="flex flex-col justify-between rounded-xl border border-white/10 bg-[#121826] p-6">
          <div>
            <div className="mb-3 flex items-center gap-2 text-gray-300">
              <Users className="h-5 w-5 text-blue-400" /> 1,248 users enrolled
            </div>
            <div className="mb-3 text-sm text-gray-300">
              <strong>Instructor:</strong> Julia Anderson (Certified Analyst)
            </div>
            <div className="mb-4 text-sm text-gray-300">
              <strong>Session Date:</strong> March 5, 2026 — 6:00 PM UTC
            </div>
            <div className="mb-4 text-sm text-gray-300">
              <strong>Duration:</strong> 2 hours | <strong>Fee:</strong> $39 USD
            </div>
          </div>

          <div className="space-y-3">
            <button className="w-full rounded-lg bg-blue-600 py-3 font-semibold transition-all hover:bg-blue-700">
              Enroll Now
            </button>
            <button className="w-full rounded-lg bg-green-600 py-3 font-semibold transition-all hover:bg-green-700">
              Book 1-to-1 Coaching
            </button>
            <button className="flex w-full items-center justify-center gap-2 rounded-lg bg-gray-800 py-3 font-semibold transition-all hover:bg-gray-700">
              <Phone className="h-4 w-4" /> Contact Support
            </button>
          </div>
        </div>
      </div>

      {/* Footer Note */}
      <div className="mt-10 border-t border-white/10 pt-4 text-center text-sm text-gray-400">
        Powered by Million2Trillion | Your SmartCard gives verified webinar
        access.
      </div>
    </section>
  );
}
